import { css } from '@emotion/react';
import { UploadIndicatorIcon } from '../Icons';
import { LAYOUT2 } from '../Styles';
import { MissingPhotoIcon } from './MissingPhotoIcon';
import { NotesCountBubble } from './NotesCountBubble';

const SCAN_THUMBNAIL_CONTAINER_STYLE = css`
  label: SCAN_THUMBNAIL_CONTAINER_STYLE;
  width: ${LAYOUT2.spacing * 12}px;
  height: ${LAYOUT2.spacing * 12}px;
  position: relative;
`;
const SCAN_THUMBNAIL_CONTAINER_STYLE_NO_PHOTO = css`
  label: SCAN_THUMBNAIL_CONTAINER_STYLE_NO_PHOTO;
  background: var(--background3);
`;

const SCAN_THUMBNAIL_STYLE = css`
  label: SCAN_THUMBNAIL_STYLE;
  width: ${LAYOUT2.spacing * 12}px;
  height: ${LAYOUT2.spacing * 12}px;
  object-fit: cover;
  border: 1px solid #0000007f;
`;

const SCAN_THUMBNAIL_UPLOAD_INDICATOR_STYLE = css`
  label: SCAN_THUMBNAIL_UPLOAD_INDICATOR_STYLE;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  pointer-events: none;
`;

export const ScanThumbnail = (
  { uri, alt, photoCount, onClick, photoSource }: {
    uri: string | undefined;
    alt?: string;
    photoCount: number;
    onClick?: () => void;
    photoSource?: 'camera' | 'upload';
  },
) => (
  <div
    css={[SCAN_THUMBNAIL_CONTAINER_STYLE, !uri && SCAN_THUMBNAIL_CONTAINER_STYLE_NO_PHOTO]}
    onClick={onClick
      ? (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        onClick();
      }
      : undefined}
    style={{ cursor: onClick ? 'pointer' : 'default' }}
  >
    {uri
      ? <img src={uri} alt={alt} css={SCAN_THUMBNAIL_STYLE} />
      : <MissingPhotoIcon />}
    {photoSource === 'upload' && (
      <div css={SCAN_THUMBNAIL_UPLOAD_INDICATOR_STYLE}>
        <UploadIndicatorIcon size={24} />
      </div>
    )}
    {photoCount >= 2 && <NotesCountBubble count={photoCount} backgroundColor='var(--background)' />}
  </div>
);
